(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["contact-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    var contactForms = document.querySelectorAll('.contact-form__form');
    var allowedDomains = ['gmail.com', 'outlook.com', 'yahoo.com', 'icloud.com', 'hotmail.com', 'live.com'];
    
    contactForms.forEach(function(form) {
      var emailInput = form.querySelector('input[type="email"]');
      if (!emailInput) return;
      
      var autoCloseTimer = null;
      
      // Create tooltip container
      var tooltip = document.createElement('div');
      tooltip.className = 'contact-form__email-tooltip';
      
      // Create tooltip content
      var tooltipContent = document.createElement('span');
      tooltipContent.className = 'contact-form__email-tooltip-text';
      tooltipContent.textContent = 'Please use a valid email address (Gmail, Outlook, Yahoo, or iCloud only)';
      
      // Create close button
      var closeBtn = document.createElement('button');
      closeBtn.className = 'contact-form__email-tooltip-close';
      closeBtn.type = 'button';
      closeBtn.innerHTML = '&times;';
      closeBtn.setAttribute('aria-label', 'Close');
      
      tooltip.appendChild(tooltipContent);
      tooltip.appendChild(closeBtn);
      
      // Wrap email input in a container for proper tooltip positioning
      var emailWrapper = document.createElement('div');
      emailWrapper.className = 'contact-form__email-wrapper';
      emailInput.parentNode.insertBefore(emailWrapper, emailInput);
      emailWrapper.appendChild(emailInput);
      emailWrapper.appendChild(tooltip);
      
      function showTooltip() {
        tooltip.classList.add('is-visible');
        emailInput.style.borderColor = '#e31837';
        
        // Clear any existing timer
        if (autoCloseTimer) {
          clearTimeout(autoCloseTimer);
        }
        
        // Auto close after 3 seconds
        autoCloseTimer = setTimeout(function() {
          hideTooltip();
        }, 3000);
      }
      
      function hideTooltip() {
        tooltip.classList.remove('is-visible');
        emailInput.style.borderColor = '';
        if (autoCloseTimer) {
          clearTimeout(autoCloseTimer);
          autoCloseTimer = null;
        }
      }
      
      // Close button click handler
      closeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        hideTooltip();
      });
      
      function validateEmailDomain(email) {
        if (!email) return false;
        var domain = email.split('@')[1];
        if (!domain) return false;
        return allowedDomains.some(function(d) {
          return domain.toLowerCase() === d;
        });
      }
      
      emailInput.addEventListener('blur', function() {
        var email = this.value.trim();
        if (email && !validateEmailDomain(email)) {
          showTooltip();
        } else {
          hideTooltip();
        }
      });
      
      form.addEventListener('submit', function(e) {
        var email = emailInput.value.trim();
        if (!validateEmailDomain(email)) {
          e.preventDefault();
          showTooltip();
          emailInput.focus();
          return false;
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media"] && !Shopify.designMode) return;
  try {
    // Initialize lazy loading for product media images
  function initProductMediaLoading() {
    const mediaContainers = document.querySelectorAll('.product-media.lazy-image-container:not(.loaded)');
    mediaContainers.forEach(container => {
      const img = container.querySelector('.product-media__image');
      if (!img) return;
      
      if (img.complete && img.naturalHeight !== 0) {
        container.classList.add('loaded');
      } else {
        img.addEventListener('load', () => container.classList.add('loaded'), { once: true });
        img.addEventListener('error', () => container.classList.add('loaded'), { once: true });
      }
    });
  }
  
  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductMediaLoading);
  } else {
    initProductMediaLoading();
  }
  
  // Re-run when new content is added (for infinite scroll, etc.)
  const observer = new MutationObserver((mutations) => {
    let hasNewMedia = false;
    mutations.forEach(mutation => {
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1 && (node.classList?.contains('product-media') || node.querySelector?.('.product-media'))) {
            hasNewMedia = true;
          }
        });
      }
    });
    if (hasNewMedia) {
      initProductMediaLoading();
    }
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
  } catch(e) { console.error(e); }
})();

})();
